import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=e6cda784&scoped=true"
import script from "./BannerCard.vue?vue&type=script&lang=ts"
export * from "./BannerCard.vue?vue&type=script&lang=ts"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=e6cda784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cda784",
  null
  
)

export default component.exports